<ng-container *ngIf="type === 'light' && size == 'sm'">
  <button mat-button="" class="btn-outline-sm btn-outline-light">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'light' && size == 'md'">
  <button mat-button="" class="btn-outline-md btn-outline-light">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'light' && size == 'lg'">
  <button mat-button="" class="btn-outline-lg btn-outline-light">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'secondary' && size == 'sm'">
  <button mat-button="" class="btn-outline-sm btn-outline-outline">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'secondary' && size == 'md'">
  <button mat-button="" class="btn-outline-md btn-outline-secondary">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'secondary' && size == 'lg'">
  <button mat-button="" class="btn-outline-lg btn-outline-secondary">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'danger' && size == 'sm'">
  <button mat-button="" class="btn-outline-sm btn-outline-danger">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'danger' && size == 'md'">
  <button mat-button="" class="btn-outline-md btn-outline-danger">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'danger' && size == 'lg'">
  <button mat-button="" class="btn-outline-lg btn-outline-danger">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'dark' && size == 'sm'">
  <button mat-button="" class="btn-outline-sm btn-outline-dark">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'dark' && size == 'md'">
  <button mat-button="" class="btn-outline-md btn-outline-dark">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type === 'dark' && size == 'lg'">
  <button mat-button="" class="btn-outline-lg btn-outline-dark">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type == undefined && size == 'sm'">
  <button mat-button="" class="btn-outline-sm btn-outline-default">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type == undefined && size == 'md'">
  <button mat-button="" class="btn-outline-md btn-outline-default">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="type == undefined && size == 'lg'">
  <button mat-button="" class="btn-outline-lg btn-outline-default">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
</ng-container>

<ng-template #contentTpl=""><ng-content></ng-content></ng-template>
